import React from "react";
import { FaEdit } from "react-icons/fa";
import {  DeleteOutlined } from "@ant-design/icons";
import { BiChevronLeft, BiChevronRight } from "react-icons/bi";
import sanitizeHtml from "sanitize-html";
import { Link } from "react-router-dom";
import { Faq } from "../../../../APIs/faq";

interface FAQTableProps {
  faqs: Faq[];
  loading: boolean;
  currentPage: number;
  pageNumbers: any[];
  currentFaqs: any[];
  handlePageChange: (e: any) => void;
  handleDeleteFAQ:(e: any) => void;
 
}

const FAQTable: React.FC<FAQTableProps> = ({
  faqs,
  loading,
 
  currentPage,
  pageNumbers,
  currentFaqs,
  handlePageChange,
  handleDeleteFAQ
}) => {
 
  const sanitizeFAQText = (html: string) => {
    return sanitizeHtml(html, {
      allowedTags: ["b", "i", "em", "strong", "a", "p", "br", "ul", "li", "ol"], // Customize allowed tags
      allowedAttributes: {
        a: ["href"],
      },
    });
  };

  const truncateText = (text: string, wordLimit: number) => {
    const words = text.split(" ");
    return words.length > wordLimit
      ? words.slice(0, wordLimit).join(" ") + "..."
      : text;
  };

  return (
    <div className="flex flex-col text-black">
      <div className="overflow-x-auto sm:-mx-6 lg:-mx-8">
        <div className="inline-block min-w-full py-2 sm:px-6 lg:px-8">
          <div className="overflow-hidden  rounded-lg">
            <table className="min-w-full text-sm">
              <thead className="text-xs text-gray-700 dark:text-gray-400">
                <tr className="bg-gray-100 text-black text-[16px] h-[65px]">
                  <th scope="col" className="px-6 py-3">
                    Question
                  </th>

                  <th scope="col" className="px-6 py-3">
                    Answer
                  </th>

                  <th scope="col" className="px-6 py-3">
                    Actions
                  </th>
                </tr>
              </thead>
              <tbody className="text-blue">
                {loading ? (
                  <tr>
                    <td colSpan={5} className="text-center py-4">
                      Loading...
                    </td>
                  </tr>
                ) : (
                  currentFaqs.map((faq) => (
                    <tr
                      key={faq.id}
                      className="hover:bg-gray-100 transition duration-200 text-[#75A7AD]">
                      <td className="border-b p-3 font-semibold text-black">
                        {faq.question}
                      </td>

                      <td className="border-b p-3">
                        <div
                          dangerouslySetInnerHTML={{
                            __html: sanitizeFAQText(
                              truncateText(faq.answer, 60)
                            ),
                          }}
                        />
                      </td>

                      <div className="flex items-center space-x-4">
                      <td className="border-b p-3">
                        <Link to={`/dashboard/editfaq/${faq.id}`}>
                          <span
                              // onClick={() => handleEditOrder(blog)}
                            className="text-[#75A7AD] cursor-pointer  hover:text-gray-800 flex items-center"
                            title="Edit Order">
                            <FaEdit className="mr-1  text-[#75A7AD]" />
                            Edit
                          </span>
                        </Link>
                      </td>
                        <span
                          onClick={() =>   handleDeleteFAQ(faq.id)}
                          className="text-[#FF6347] cursor-pointer hover:text-gray-800 flex items-center"
                          title="Delete Order">
                          <DeleteOutlined className="mr-1" />
                          Delete
                        </span>
                      </div>

                      {/* <td className="border-b p-3">
                        <Link to={`/dashboard/edit/${faq.id}`}>
                          <span
                            onClick={() => handleEditFAQ(faq)} 
                            className="text-[#75A7AD] cursor-pointer hover:text-gray-800 flex items-center"
                            title="Edit FAQ">
                            <FaEdit className="mr-1 text-[#75A7AD]" />
                            Edit
                          </span>
                        </Link>
                        <span
                          // onClick={() => handleDeleteFAQ(faq.id)}
                          className="text-[#FF6347] cursor-pointer hover:text-gray-800 flex items-center"
                          title="Delete FAQ">
                          <DeleteOutlined className="mr-1" />
                          Delete
                        </span>
                      </td> */}
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <div className="flex space-x-4 mt-[20px] justify-end">
        <section className="inline-flex col row">
          <div className="flex">
            {currentPage > 1 && (
              <button
                onClick={() => handlePageChange(currentPage - 1)}
                className="rounded-full h-8 px-1 font-semibold bg-white ml-[10px]">
                <BiChevronLeft size={30} className="text-black" />
              </button>
            )}

            {pageNumbers.map(
              (number, index) =>
                currentPage <= index + 2 &&
                index + 1 <= currentPage + 2 && (
                  <div className="flex space-x-3" key={number}>
                    <button
                      className="rounded-full h-8 px-3 font-semibold text-white"
                      onClick={() => handlePageChange(number)}
                      style={{
                        backgroundColor:
                          number === currentPage ? "#75A7AD" : "white",
                        color: number === currentPage ? "white" : "black",
                      }}>
                      {number}
                    </button>
                  </div>
                )
            )}

            {currentPage < pageNumbers.length && (
              <button
                className="rounded-full h-8 px-1 font-semibold bg-white ml-[10px]"
                onClick={() => handlePageChange(currentPage + 1)}>
                <BiChevronRight size={30} className="text-black" />
              </button>
            )}
          </div>
        </section>
        <section className="flex space-x-8 p-2">
          <h5 className="font-bold text-black text-xs mr-[-20px]">
            FAQ per page
          </h5>
          <select
            id="faq-per-page"
            className="mt-[-8px] w-[90px] py-2 block rounded-md focus:outline-none text-black text-sm bg-white"
            name="role"
            value={currentPage}
            onChange={(e) => handlePageChange(Number(e.target.value))}>
            {pageNumbers.map((option: number) => (
              <option key={option} value={option}>
                {option}
              </option>
            ))}
          </select>
        </section>
      </div>
    </div>
  );
};

export default FAQTable;
